import { render, staticRenderFns } from "./matchResDetail.vue?vue&type=template&id=1312e9ca&scoped=true"
import script from "./matchResDetail.vue?vue&type=script&lang=js"
export * from "./matchResDetail.vue?vue&type=script&lang=js"
import style0 from "./matchResDetail.vue?vue&type=style&index=0&id=1312e9ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1312e9ca",
  null
  
)

export default component.exports